import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { getLogger } from '../../util/logger';
import bureaucrat from '../../util/Bureaucrat';
import { parseErrorMessage } from '../util/dataHelpers';

const logger = getLogger('useBillingProfileFormHandlers');

export const useBillingProfileFormHandlers = (onComplete, onCancel) => {
  const [errorMsg, setErrorMsg] = useState('');
  const history = useHistory();

  const handleSubmit = (values, actions) => {
    scroll.scrollToTop();
    logger.debug(values);

    bureaucrat
      .updateBillingProfile(
        values.companyName,
        values.addressLine1,
        values.addressLine2,
        values.city,
        values.state,
        values.postalCode,
        values.firstName,
        values.lastName,
        values.email,
        values.phoneNumber,
      )
      .then(() => onComplete())
      .catch((error) => {
        actions.setSubmitting(false);
        parseErrorMessage(error, setErrorMsg, history);
      });
  };

  const handleCancel = (event) => {
    event.preventDefault();
    onCancel();
  };

  return { handleSubmit, handleCancel, errorMsg };
};
